import ReactEChartsCore from '../EChart';
import * as echarts from 'echarts/core';
import { useAppContext } from '../../../providers/AppProvider';
import { TooltipComponent, GraphicComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([TooltipComponent, GraphicComponent, PieChart, CanvasRenderer]);

const colorKeys = [
  'info-300',
  'warning-300',
  'danger-300',
  'success-300',
  'primary',
  'secondary',
  'info',
  'warning',
  'success'
];

const formatKg = value =>
  Number(value || 0).toLocaleString('ro-RO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
  });

const prettyWireType = wireType => {
  const t = String(wireType || '')
    .trim()
    .toUpperCase();
  if (t === 'SINGLE-WIRE') return 'Solid Copper';
  if (t === 'STRANDED') return 'Stranded Copper';
  if (t === 'MULTI-WIRE') return 'Multi-Wire Copper';
  return 'Copper';
};

const getDefaultOptions = (getThemeColor, data, totalKg) => ({
  color: colorKeys.map(key => getThemeColor(key)),
  tooltip: {
    trigger: 'item',
    formatter: params => {
      return `
        <strong>${params?.name || ''}</strong><br/>
        ${params?.marker || ''} Needed: <strong>${formatKg(params?.value)} kg</strong>
      `;
    }
  },
  series: [
    {
      name: 'Copper quantity needed',
      type: 'pie',
      radius: ['48%', '90%'],
      startAngle: 30,
      avoidLabelOverlap: false,
      label: {
        show: false,
        position: 'center',
        formatter: '{x|{d}%} \n {y|{b}}',
        rich: {
          x: {
            fontSize: 31.25,
            fontWeight: 800,
            color: getThemeColor('gray-700'),
            padding: [0, 0, 5, 15]
          },
          y: {
            fontSize: 12.8,
            color: getThemeColor('gray-700'),
            fontWeight: 600
          }
        }
      },
      emphasis: {
        label: {
          show: true
        }
      },
      labelLine: {
        show: false
      },
      data: data.map(item => ({
        value: Number(item.planned_kg || 0),
        name: `${prettyWireType(item.wireType)} ${item.wireDiameter}`
      }))
    }
  ],
  graphic: [
    {
      type: 'text',
      left: 'center',
      top: '44%',
      style: {
        text: formatKg(totalKg),
        textAlign: 'center',
        fill: getThemeColor('gray-1100'),
        fontSize: 22,
        fontWeight: 800,
        fontFamily: 'Nunito Sans'
      }
    },
    {
      type: 'text',
      left: 'center',
      top: '54%',
      style: {
        text: 'kg total',
        textAlign: 'center',
        fill: getThemeColor('gray-700'),
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'Nunito Sans'
      }
    }
  ]
});

const OrderCopperDonutChart = ({ data = [], totalKg = 0 }) => {
  const { getThemeColor } = useAppContext();

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getDefaultOptions(getThemeColor, data, totalKg)}
      style={{ minHeight: '360px', width: '100%' }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default OrderCopperDonutChart;
